import { render, staticRenderFns } from "./PdfPreviewMagnificationComponent.vue?vue&type=template&id=102da6ac&lang=pug"
import script from "./PdfPreviewMagnificationComponent.vue?vue&type=script&lang=ts"
export * from "./PdfPreviewMagnificationComponent.vue?vue&type=script&lang=ts"
import style0 from "./PdfPreviewMagnificationComponent.vue?vue&type=style&index=0&id=102da6ac&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('102da6ac')) {
      api.createRecord('102da6ac', component.options)
    } else {
      api.reload('102da6ac', component.options)
    }
    module.hot.accept("./PdfPreviewMagnificationComponent.vue?vue&type=template&id=102da6ac&lang=pug", function () {
      api.rerender('102da6ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/Preview/components/PdfPreviewComponent/PdfPreviewMagnificationComponent.vue"
export default component.exports